export const inProduction = (): boolean => process.env.REACT_APP_ENV === "production";

export const getId = (extId: string, baseId: string | undefined): string | undefined => {
  if (!baseId) return undefined;
  return baseId + "-" + extId;
};
